var map = {
	"./basics": "I1S3",
	"./basics.json": "I1S3",
	"./blog/coming-soon": "v1j+",
	"./blog/coming-soon.json": "v1j+",
	"./blog/fostering-compassion-and-self-compassion-during-the-corona-virus-pandemic": "YfaY",
	"./blog/fostering-compassion-and-self-compassion-during-the-corona-virus-pandemic.json": "YfaY",
	"./cms": "MhV0",
	"./cms.js": "MhV0",
	"./forgiveness": "HmTd",
	"./forgiveness.json": "HmTd",
	"./home": "s1BV",
	"./home.json": "s1BV",
	"./insurance": "D9Q3",
	"./insurance.json": "D9Q3",
	"./techniques": "U7Lr",
	"./techniques.json": "U7Lr",
	"./training": "ErF+",
	"./training.json": "ErF+",
	"./workshops": "7k6A",
	"./workshops.json": "7k6A"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "o+CK";